import * as React from "react";

export const IndicatorAlert = (props: any) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 17.333A8.333 8.333 0 1 1 9 .667a8.333 8.333 0 1 1 0 16.666Zm0-1.666A6.666 6.666 0 1 0 9 2.334a6.666 6.666 0 0 0 0 13.333ZM8.167 11.5h1.666v1.667H8.167V11.5Zm0-6.667h1.666v5H8.167v-5Z"
      fill="#ED6C02"
    />
  </svg>
);
